/**
 * Softeq Development Corporation
 * https://www.softeq.com
 */

import { Observable } from 'rxjs';
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { PageEvent } from '@angular/material';
import {
  Response,
  SearchReposParams,
  SearchReposResponse,
} from '@octokit/rest';
import { QuoteService, GithubService, Quote } from './resources';

const DEFAULT_SEARCH_PARAMS: SearchReposParams = {
  q: 'org:Softeq+is:public',
  sort: 'stars',
  page: 1,
  per_page: 6,
};

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  @ViewChild('appExplorer', { static: false })
  public appExplorerEl: ElementRef;
  public perPage: number = DEFAULT_SEARCH_PARAMS.per_page;
  public quote$: Observable<Quote>;
  public repos: Response<SearchReposResponse>;

  constructor(
    private quote: QuoteService,
    private github: GithubService,
  ) {
  }

  public async ngOnInit(): Promise<void> {
    this.quote$ = this.quote.getQuote();
    await this.github.authenticate();
    this.getRepos(DEFAULT_SEARCH_PARAMS);
  }

  public changePage(event: PageEvent): void {
    const params = Object.assign({}, DEFAULT_SEARCH_PARAMS, {
      page: event.pageIndex + 1,
    });

    this.getRepos(params, true);
  }

  public search(value: string): void {
    const params = Object.assign({}, DEFAULT_SEARCH_PARAMS, {
      q: DEFAULT_SEARCH_PARAMS.q + `+${value}+in:name+in:readme+in:description`,
      page: 1,
    });

    this.getRepos(params, true);
  }

  private getRepos(params: SearchReposParams, scroll: boolean = false): void {
    this.github
      .getRepos(params)
      .subscribe((repos) => {
        this.repos = repos;

        if (scroll) {
          this.appExplorerEl.nativeElement.scrollIntoView();
        }
      });
  }
}
